const Warning = () => (
  <svg viewBox="0 0 22 22" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 7V11" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 15H11.01" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default Warning;
